import { ResponseCachedDecorator } from '@nts/std';
import { ResponseResultTypeDecorator, GenericServiceResponse } from '@nts/std';
import { MenuNodeUiWithChildren } from '../domain-models/menu-node-ui-with-children';

@ResponseResultTypeDecorator(MenuNodeUiWithChildren)
@ResponseCachedDecorator()
export class GetRootNodesResponse extends GenericServiceResponse<MenuNodeUiWithChildren[]> {

}
